import React, { useState } from 'react';
import AceEditor from 'react-ace';
import { format as formatSQL } from 'sql-formatter';

// AceEditor themes and modes
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/theme-github';

// Your CSS
import './sqltutorial.css';

function SqlFormatter() {
  const [query, setQuery] = useState('');
  const [message, setMessage] = useState(''); // Added state for the message

  const formatQuery = () => {
    try {
      const formattedQuery = formatSQL(query);
      setQuery(formattedQuery);
      setMessage('SQL formatted successfully!'); // Set success message
    } catch (err) {
      console.error('Error formatting SQL:', err);
      setMessage('Error formatting SQL'); // Set error message
      // Optionally, handle the error in the UI as well
    }
  };

  return (
    <div className="app-container">
      <h1>SQL Formatter</h1>
      <div className="query-input">
        <AceEditor
          mode="sql"
          theme="github"
          name="queryEditor"
          value={query}
          onChange={setQuery}
          wrapEnabled={true}
          fontSize={14}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          setOptions={{
            enableBasicAutocompletion: false,
            enableLiveAutocompletion: false,
            enableSnippets: false,
            showLineNumbers: true,
            tabSize: 2,
          }}
          style={{ width: '100%', minHeight: '50px', maxHeight: "150px" }}
        />
        <button onClick={formatQuery} style={{ marginTop: '10px' }}>Format SQL</button>
        {message && <div style={{ marginTop: '10px' }}>{message}</div>} {/* Display message */}
      </div>
    </div>
  );
}

export default SqlFormatter;